import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@/i18n";
import { initSentry } from "@/lib/sentry";

// Sentry's own GlobalHandlers integration (default-on) already installs
// window `error`/`unhandledrejection` listeners — see lib/error-log.ts,
// still used directly by ErrorBoundary for render-tree errors Sentry's
// global listeners don't see.
initSentry();

createRoot(document.getElementById("root")!).render(<App />);

